<div class="modal fade" id="kt_modal_transport_pickup_bulk_update" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">

      <!-- Header -->
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">
          Bulk Update Transport Pickups
          <span class="badge badge-primary ms-2">{{ itemsArray.length }} items</span>
        </h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Form -->
      <form [formGroup]="bulkForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5" style="max-height: 68vh; overflow-y: auto;">

          <!-- Empty state -->
          <div *ngIf="itemsArray.length === 0" class="text-center py-10 text-muted">
            No items selected for update.
          </div>

          <div formArrayName="items">
            <div
              *ngFor="let item of itemsArray.controls; let i = index"
              [formGroupName]="i"
              class="card border border-dashed border-gray-300 shadow-sm mb-5">

              <!-- Card Header: Vehicle Info -->
              <div class="card-header bg-light-primary min-h-45px d-flex align-items-center">
                <h6 class="fw-bold m-0 text-primary d-flex flex-wrap align-items-center gap-3">
                  <span>
                    <i class="ki-duotone ki-car fs-4 me-1">
                      <span class="path1"></span><span class="path2"></span>
                    </i>
                    {{ rowStates[i]?.vehicleInfo?.car_no || ('Vehicle ' + (i + 1)) }}
                  </span>
                  <span class="text-muted fs-7" *ngIf="rowStates[i]?.vehicleInfo?.inventory_no">
                    Lot: {{ rowStates[i]?.vehicleInfo?.inventory_no }}
                  </span>
                  <span class="text-muted fs-7" *ngIf="rowStates[i]?.vehicleInfo?.vin_no">
                    Chassis: {{ rowStates[i]?.vehicleInfo?.vin_no }}
                  </span>
                </h6>
              </div>

              <!-- Card Body: Fields -->
              <div class="card-body p-4">
                <div class="row">

                  <!-- Order Date -->
                  <div class="col-md-4 mb-4">
                    <label class="form-label">Order Date</label>
                    <input type="date" class="form-control form-control-solid" formControlName="order_date" />
                  </div>

                  <!-- Yard In -->
                  <div class="col-md-4 mb-4">
                    <label class="form-label">Yard In</label>
                    <input type="date" class="form-control form-control-solid" formControlName="yard_in" />
                  </div>

                  <!-- Out Date -->
                  <div class="col-md-4 mb-4">
                    <label class="form-label">Out Date</label>
                    <input type="date" class="form-control form-control-solid" formControlName="out_date" />
                  </div>

                  <!-- Yard Out -->
                  <div class="col-md-4 mb-4">
                    <label class="form-label">Yard Out</label>
                    <input type="date" class="form-control form-control-solid" formControlName="yard_out" />
                  </div>

                  <!-- Pos No -->
                  <div class="col-md-4 mb-4">
                    <label class="form-label">Pos No</label>
                    <input type="text" class="form-control form-control-solid" formControlName="pos_no" placeholder="Enter pos number" />
                  </div>

                  <!-- Pickup From -->
                  <div class="col-md-4 mb-4">
                    <label class="form-label">Pickup From</label>
                    <div class="position-relative">
                      <input
                        type="text"
                        class="form-control form-control-solid"
                        [value]="rowStates[i]?.pickupFromSearchTerm"
                        (input)="onRowPickupFromSearchInput($event, i)"
                        (blur)="onRowPickupFromInputBlur(i)"
                        placeholder="Search auction halls..."
                        autocomplete="off"
                      />
                      <div *ngIf="rowStates[i]?.isPickupFromSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
                        <span class="spinner-border spinner-border-sm text-primary"></span>
                      </div>
                      <div *ngIf="rowStates[i]?.showPickupFromDropdown" class="dropdown-menu show w-100 mt-1" style="max-height: 200px; overflow-y: auto; z-index: 1060;">
                        <div *ngIf="rowStates[i]?.pickupFromSearchResults?.length === 0 && !rowStates[i]?.isPickupFromSearching" class="dropdown-item-text text-muted">
                          No auction halls found
                        </div>
                        <div
                          *ngFor="let pf of rowStates[i]?.pickupFromSearchResults"
                          class="dropdown-item cursor-pointer py-2"
                          (mousedown)="selectRowPickupFrom(pf, i)">
                          <div class="fw-bold text-dark fs-7">{{ pf.name || pf.company_name || 'Unknown' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Delivered At -->
                  <div class="col-md-4 mb-4">
                    <label class="form-label">Delivered At</label>
                    <div class="position-relative">
                      <input
                        type="text"
                        class="form-control form-control-solid"
                        [value]="rowStates[i]?.deliveredAtSearchTerm"
                        (input)="onRowDeliveredAtSearchInput($event, i)"
                        (blur)="onRowDeliveredAtInputBlur(i)"
                        placeholder="Search delivery locations..."
                        autocomplete="off"
                      />
                      <div *ngIf="rowStates[i]?.isDeliveredAtSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
                        <span class="spinner-border spinner-border-sm text-primary"></span>
                      </div>
                      <div *ngIf="rowStates[i]?.showDeliveredAtDropdown" class="dropdown-menu show w-100 mt-1" style="max-height: 200px; overflow-y: auto; z-index: 1060;">
                        <div *ngIf="rowStates[i]?.deliveredAtSearchResults?.length === 0 && !rowStates[i]?.isDeliveredAtSearching" class="dropdown-item-text text-muted">
                          No delivery locations found
                        </div>
                        <div
                          *ngFor="let da of rowStates[i]?.deliveredAtSearchResults"
                          class="dropdown-item cursor-pointer py-2"
                          (mousedown)="selectRowDeliveredAt(da, i)">
                          <div class="fw-bold text-dark fs-7">{{ da.company_name || da.delivered_at || 'Unknown' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Transport Company -->
                  <div class="col-md-4 mb-4">
                    <label class="form-label">Transport Company</label>
                    <div class="position-relative">
                      <input
                        type="text"
                        class="form-control form-control-solid"
                        [value]="rowStates[i]?.vendorSearchTerm"
                        (input)="onRowVendorSearchInput($event, i)"
                        (blur)="onRowVendorInputBlur(i)"
                        placeholder="Search transport companies..."
                        autocomplete="off"
                      />
                      <div *ngIf="rowStates[i]?.isVendorSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
                        <span class="spinner-border spinner-border-sm text-primary"></span>
                      </div>
                      <div *ngIf="rowStates[i]?.showVendorDropdown" class="dropdown-menu show w-100 mt-1" style="max-height: 200px; overflow-y: auto; z-index: 1060;">
                        <div *ngIf="rowStates[i]?.vendorSearchResults?.length === 0 && !rowStates[i]?.isVendorSearching" class="dropdown-item-text text-muted">
                          No transport companies found
                        </div>
                        <div
                          *ngFor="let v of rowStates[i]?.vendorSearchResults"
                          class="dropdown-item cursor-pointer py-2"
                          (mousedown)="selectRowVendor(v, i)">
                          <div class="fw-bold text-dark fs-7">{{ v.company_name || 'Unknown' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Transport Cost -->
                  <div class="col-md-4 mb-4">
                    <label class="form-label">Transport Cost</label>
                    <input type="number" class="form-control form-control-solid" formControlName="transport_cost" placeholder="Enter transport cost" min="0" />
                  </div>

                  <!-- Comment for transporter -->
                  <div class="col-md-6 mb-4">
                    <label class="form-label">Comment for Transporter</label>
                    <textarea
                      class="form-control form-control-solid"
                      formControlName="comment_for_transporter"
                      placeholder="Enter comment for transporter"
                      rows="2">
                    </textarea>
                  </div>

                  <!-- Admin Comment -->
                  <div class="col-md-6 mb-4">
                    <label class="form-label">Admin Comment</label>
                    <textarea
                      class="form-control form-control-solid"
                      formControlName="admin_comment"
                      placeholder="Enter admin comment"
                      rows="2">
                    </textarea>
                  </div>

                </div><!-- /row -->
              </div><!-- /card-body -->
            </div><!-- /card -->
          </div><!-- /formArrayName -->

        </div><!-- /modal-body -->

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-light me-3" data-bs-dismiss="modal" [disabled]="isLoading">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="isLoading || itemsArray.length === 0">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!isLoading" class="ki-duotone ki-check fs-4 me-1">
              <span class="path1"></span>
            </i>
            {{ isLoading ? 'Updating...' : 'Update All (' + itemsArray.length + ')' }}
          </button>
        </div>

      </form>
    </div>
  </div>
</div>

